
import './App.css';
import Home from './pages/Home';
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  BrowserRouter,
  Routes,
} from "react-router-dom";

import Register from './pages/Register';
import Login from './pages/Login';
import PageNotFound from './pages/404';
import Main from './components/nav/Main';
import React from 'react';
import { AuthProvider } from './context/auth';
import ForgotPassword from './pages/ForgotPassword';
import Rest from './pages/Rest';
import DashBoard from './pages/DashBoard';
import PrivateRoute from './components/route/PrivateRoute';
import Tasks from './pages/Tasks';
import { TaskProvider } from './context/task';
import { SelectProvider } from './context/select';
import { TotalViewProvider } from './context/totalview';


function App() {
  return (
    <AuthProvider>
      <TaskProvider>
        <SelectProvider>
          <TotalViewProvider>
          <BrowserRouter>
            <Main />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/register' element={<Register />} />
              <Route path='/login' element={<Login />} />
              <Route path='/forgot-password' element={<ForgotPassword />} />
              <Route path='/rest' element={<Rest />} />
              <Route path='/dashboard' element={<PrivateRoute />} >

                <Route path='' element={<DashBoard />} />
                <Route path='tasks' element={<Tasks />} />
              </Route>
              {/* <Route path='/rest' element={<Rest />} /> */}
              <Route path='*' element={<PageNotFound />} />

            </Routes>
          </BrowserRouter>
          </TotalViewProvider>
        </SelectProvider>
      </TaskProvider>
    </AuthProvider>
  );
}

export default App;
